module.exports = __webpack_public_path__ + "static/img/news1.bf932f18.png";